import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyChartPieComponent } from './chart-pie.component';
import { Ng2GoogleChartsModule } from 'ng2-google-charts';

@NgModule({
  declarations: [
    MyChartPieComponent,
  ],
  imports: [
    CommonModule,
    Ng2GoogleChartsModule
  ],
  exports: [
    MyChartPieComponent
  ]
})
export class MyChartPieModule { }



// WEBPACK FOOTER //
// ./src/app/shared/charts/chart-pie/chart-pie.module.ts